var _circle, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMinergieLabel(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 17.47,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.57,18.39v1.01c0,.64.31.96.92.96s.96-.32.96-.96c0-3.42.3-4.39,2.44-5.73-1,1.36-1.52,2.67-1.62,4.23,3.01.66,3.99-.72,4.72-3.06.28-.92.56-1.94,1.69-3.59-5.17-.41-9.11.98-9.11,7.14Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.21,22.02c1.32-1.73,2.12-3.89,2.12-6.24,0-5.72-4.53-10.33-10.33-10.33s-10.32,4.62-10.32,10.33c0,2.33.78,4.47,2.08,6.19l-3.96,8.15,4.99.54,3.33,3.89,3.86-8.45s.01,0,.02,0,.01,0,.02,0c.04.1,3.87,8.45,3.87,8.45l3.32-3.89,4.99.57-3.99-9.21ZM20,24.23c-4.65,0-8.45-3.78-8.45-8.45s3.7-8.45,8.45-8.45,8.45,3.79,8.45,8.45-3.79,8.45-8.45,8.45Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.21,22.38c1.32-1.73,2.12-3.89,2.12-6.24,0-5.72-4.53-10.33-10.33-10.33s-10.32,4.62-10.32,10.33c0,2.33.78,4.47,2.08,6.19l-3.96,8.15,4.99.54,3.33,3.89,3.86-8.45s.01,0,.02,0,.01,0,.02,0c.04.1,3.87,8.45,3.87,8.45l3.32-3.89,4.99.57-3.99-9.21ZM20,7.69c4.75,0,8.45,3.79,8.45,8.45s-3.79,8.45-8.45,8.45-8.45-3.78-8.45-8.45,3.7-8.45,8.45-8.45Z",
    fill: "#3d8b6a"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.49,20.72c.64,0,.96-.32.96-.96,0-3.42.3-4.39,2.44-5.73-1,1.36-1.52,2.67-1.62,4.23,3.01.66,3.99-.72,4.72-3.06.28-.92.56-1.94,1.69-3.59-5.17-.41-9.11.98-9.11,7.14v1.01c0,.64.31.96.92.96Z",
    fill: "#3d8b6a"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinergieLabel);
export default __webpack_public_path__ + "static/media/minergie-label.c9541cd1b3118a9a82d61405e0f6633b.svg";
export { ForwardRef as ReactComponent };